import { useParams, Navigate } from "react-router-dom";
import ServicePage from "./ServicePage";
import SuburbPage from "./SuburbPage";
import { SERVICES, SUBURBS } from "../data/site";

export default function SlugRouter() {
  const { slug } = useParams();
  if (SERVICES.some((s) => s.slug === slug)) return <ServicePage />;
  if (SUBURBS.some((s) => s.slug === slug)) return <SuburbPage />;
  return <Navigate to="/" replace />;
}
